import moment from 'jalali-moment'
export default {
  methods: {
    giveMeDay(start, now, end) {
      start = new Date(start)
      now = new Date(now)
      end = new Date(end)

      // mizane darsadi ke pishrafte
      if (now.getMonth() - start.getMonth() === 0) {
        if (now.getDay() - start.getDay() === 0) {
          if (now.getHours() - start.getHours() === 0) {
            if (now.getMinute() - start.getMinute() === 0) {
              console.log('d')
            } else {
              let totalMinutes = end.getMinute() - start.getMinute()
              return (now.getMinute() / totalMinutes) * 100
            }
          } else {
            let totalHours = end.getHours() - start.getHours()
            return (now.getHours() - totalHours) * 10
          }
        } else {
          let totalDays = Math.abs(end.getDay() - start.getDay())
          return (now.getDay() / totalDays) * 100
        }
      } else {
        let totalMonths = Math.abs(end.getMonth() - start.getMonth())
        return (now.getMonth() / totalMonths) * 100
      }
    },
    convertDate(date) {
      return moment(date).locale('fa').format('YYYY/MM/DD')
    },
    convertJustDate(date) {
      return moment(date).locale('fa').format('YYYY/MM/DD')
    },
    convertFullDateTime(data) {
      const dateNum = moment(data).locale('fa').format('DD')
      const date = moment(data).locale('fa').format('dddd')
      const month = moment(data).locale('fa').format('MMMM')
      const time = moment(data).locale('fa').format('HH:mm')
      return date + ' ' + dateNum + ' ' + month + '، ساعت ' + time
    },
    convertTime(data) {
      const time = moment(data).locale('fa').format('HH:mm')
      return time
    },
    FormatedDate(notificationTime) {
      const dateFormat = new Intl.DateTimeFormat('fa', { hour: '2-digit', minute: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit' })
      return dateFormat.format(Date.parse(notificationTime)).replace(',', ' ')
    },
    FullDate(data) {
      const dateNum = moment(data).locale('fa').format('DD')
      const month = moment(data).locale('fa').format('MMMM')
      const year = moment(data).locale('fa').format('YYYY')
      return dateNum + ' ' + month + ' ' + year
    },
    TellMeWhen(data) {
      var date = moment(data).locale('fa').format('YYYY/MM/DD HH:mm:ss')
      var myData = {
        year: Number(moment(date).format('YYYY')),
        month: Number(moment(date).format('MM')),
        week: Number(moment(date).format('w')),
        day: Number(moment(date).format('DD')),
        hour: Number(moment(date).format('HH')),
        minute: Number(moment(date).format('mm')),
        second: Number(moment(date).format('ss')),
      }
      var today = new Date()
      today = moment(today).locale('fa').format('YYYY/MM/DD HH:mm:ss')
      var todayData = {
        year: Number(moment(today).format('YYYY')),
        month: Number(moment(today).format('MM')),
        week: Number(moment(today).format('w')),
        day: Number(moment(today).format('DD')),
        hour: Number(moment(today).format('HH')),
        minute: Number(moment(today).format('mm')),
        second: Number(moment(today).format('ss')),
      }
      if (moment(date).format('YYYY/MM/DD') === moment(today).format('YYYY/MM/DD')) {
        if (myData.hour === todayData.hour) {
          if (myData.minute == todayData.minute) {
            let sec = Math.abs(todayData.second - myData.second)
            return sec + ' ثانیه قبل'
          } else {
            return todayData.minute - myData.minute + 'دقیقه قبل'
          }
        } else {
          return todayData.hour - myData.hour + ' ساعت قبل'
        }
      } else if (myData.year == todayData.year) {
        if (myData.month == todayData.month) {
          if (myData.week == todayData.week) {
            return todayData.day - myData.day + ' روز قبل'
          } else if (0 < Math.abs(myData.week - todayData.week < 4)) {
            return todayData.week - myData.week + ' هفته قبل'
          }
          if (myData.day == todayData.day) {
            return 'امروز'
          } else if (todayData.day - myData.day == 1) {
            return 'دیروز'
          }
        } else if (0 < Math.abs(myData.week - todayData.week < 4)) {
          let x = 30 - myData.day
          let y = todayData.day
          if (x + y >= 7) {
            return Math.floor(Math.abs(x + y) / 7) + ' هفته قبل'
          } else {
            return x + y + ' روز قبل'
          }
        } else {
          return todayData.month - myData.month + ' ماه قبل'
        }
      } else {
        return todayData.year - myData.year + ' سال قبل'
      }
    },
    customTellMeWhen(data) {
      var date = moment(data).locale('fa').format('YYYY/MM/DD HH:mm:ss')
      var myData = {
        day: Number(moment(date).format('DD')),
        hour: Number(moment(date).format('HH')),
        minute: Number(moment(date).format('mm')),
        second: Number(moment(date).format('ss')),
      }
      var today = new Date()
      today = moment(today).locale('fa').format('YYYY/MM/DD HH:mm:ss')
      var todayData = {
        day: Number(moment(today).format('DD')),
        hour: Number(moment(today).format('HH')),
        minute: Number(moment(today).format('mm')),
        second: Number(moment(today).format('ss')),
      }
      if (moment(date).format('YYYY/MM/DD') === moment(today).format('YYYY/MM/DD')) {
        if (myData.hour === todayData.hour) {
          if (myData.minute == todayData.minute) {
            var sec = todayData.second - myData.second
            return sec + ' ثانیه قبل '
          } else {
            return todayData.minute - myData.minute + 'دقیقه قبل '
          }
        } else {
          return todayData.hour - myData.hour + ' ساعت قبل '
        }
      } else if (todayData.day - myData.day == 1) {
        return ' دیروز '
      } else {
        return moment(data).locale('fa').format('HH:mm YYYY/MM/DD')
      }
    },
    convertToDateAndTime(data) {
      return moment(data).locale('fa').format('HH:mm:ss YYYY/MM/DD')
    },
    timeSpanConverter(data) {
      let splitedData = data.split(':')
      let finalData = ''
      if (splitedData[0] != '00') {
        finalData = splitedData[0] + ' ساعت و ' + splitedData[1] + ' دقیقه و ' + splitedData[2] + ' ثانیه '
      } else if (splitedData[0] == '00') {
        finalData = splitedData[1] + ' دقیقه و ' + splitedData[2] + ' ثانیه '
      } else if (splitedData[0] == '00' && splitedData[1] == '00') {
        finalData = splitedData[2] + ' ثانیه '
      } else return
      return finalData
    },
  },
}
